import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StateFacade } from './+state';

@NgModule({
  imports: [CommonModule],
})
export class DomainFeatureStatesAggregatorModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainFeatureStatesAggregatorModule,
      providers: [StateFacade],
    };
  }
}
